import './LiveList.scss'
import LiveChart from "../assets/asset-stats/live-chart/LiveChart.jsx";
import {ASSET_IDS} from "../../util/asset-ids.js";
import {useSelector} from "react-redux";
import {
    FILTER_KEY_ALL,
    FILTER_KEY_CRYPTO,
    FILTER_KEY_FUNDS,
    FILTER_KEY_STOCKS,
    getSpecificAsset
} from "../../ducks/assets-duck.js";
import {useParams} from "react-router";
import AssetIcon from "../util/icons/AssetIcon.jsx";
import Preset from "./Preset.jsx";

const NAME_OVERRIDES = {
    [ASSET_IDS.DAI]: 'USD',
}

export const PRESETS = [
    {
        icon: <AssetIcon filterPreset={FILTER_KEY_ALL}/>,
        assets: [
            ASSET_IDS.ETH,
            ASSET_IDS.ELK,
            ASSET_IDS.TQQQ,
            ASSET_IDS.DAI,
        ]
    },
    {
        icon: <AssetIcon filterPreset={FILTER_KEY_CRYPTO}/>,
        assets: [
            ASSET_IDS.ETH,
            ASSET_IDS.RETH,
            ASSET_IDS.BTC,
            ASSET_IDS.SOL,
        ]
    },
    {
        icon: <AssetIcon filterPreset={FILTER_KEY_STOCKS}/>,
        assets: [
            ASSET_IDS.ELK,
            ASSET_IDS.TQQQ,
            ASSET_IDS.NIN,
            ASSET_IDS.INTC,
        ]
    },
    {
        icon: <AssetIcon filterPreset={FILTER_KEY_FUNDS}/>,
        assets: [
            ASSET_IDS.klpVER,
            ASSET_IDS.klpAGvN,
            ASSET_IDS.klpEUR,
            ASSET_IDS.klpNOR,
        ]
    }
]

export default () => {

    const {presetId} = useParams()
    const {assets} = PRESETS[presetId]

    return (
        <div className='live-list'>
            <h1 className='flex-vertical-center'>
                <div style={{marginRight: '1rem'}}>
                    Live List
                </div>
                <div className={'flex-vertical-center'}>
                    {PRESETS.map((preset, id) =>
                        <Preset
                            key={id}
                            id={id}
                            presetId={presetId}
                            {...preset}
                        />
                    )}
                </div>
            </h1>
            {assets.map(assetId => <Asset key={assetId} assetId={assetId}/>)}
        </div>
    )
}

const Asset = ({assetId}) => {
    const {
        name,
    } = useSelector(state => getSpecificAsset(state, assetId))
    return (
        <>
            <h2 className='flex-vertical-center'>
                <div>
                    {NAME_OVERRIDES[assetId] || name}
                </div>
            </h2>
            <LiveChart assetId={assetId}/>
        </>
    )
}